<template>
  <div class="sso-loading">방문객예약 페이지로 이동 중입니다.</div>
</template>

<script>
export default {
  name: "MizeCore",

  async mounted() {
    await this.moveToMizeCore();
  },

  methods: {
    async moveToMizeCore() {
      try {
        /*
         * 마이즈코어 SSO 설정
         */
        const baseUrl = "https://mize-core.co.kr/sso";

        const sharedSecret = "ySOed8Bdu1YV+D1R62XbuBBbB3IxhmcXYgGjT85CoO4=";

        const redirectPath = "/visit/request";

        /*
         * 현재 Vue 로그인 ID
         *
         * PHP의 $member['mb_id']에 해당합니다.
         * encryptUserid가 아니라 원본 userid를 사용합니다.
         */
        const loginId = (localStorage.getItem("userid") || "").trim();

        if (!loginId) {
          alert("로그인 사용자 정보를 확인할 수 없습니다.");
          this.$router.replace("/");
          return;
        }

        /*
         * 현재 UTC Unix Timestamp
         * PHP의 time()과 동일한 초 단위 값입니다.
         */
        const timestamp = Math.floor(Date.now() / 1000);

        /*
         * PHP와 동일:
         * hash_hmac(
         *   "sha256",
         *   loginId + "|" + timestamp,
         *   sharedSecret
         * )
         */
        const message = loginId + "|" + timestamp;

        const signature = await this.createHmacSignature(message, sharedSecret);

        /*
         * SSO URL 생성
         */
        const query = new URLSearchParams({
          id: loginId,
          ts: timestamp.toString(),
          sig: signature,
          redirect: redirectPath,
        });

        const ssoUrl = baseUrl + "?" + query.toString();

        /*
         * 마이즈코어로 이동
         */
        window.location.replace(ssoUrl);
      } catch (error) {
        console.error("마이즈코어 SSO 연결 오류:", error);

        alert("방문객예약 페이지 연결 중 오류가 발생했습니다.");

        this.$router.replace("/");
      }
    },

    /*
     * HMAC-SHA256 서명 생성
     * 결과는 PHP hash_hmac()과 같은 소문자 16진수 문자열입니다.
     */
    async createHmacSignature(message, sharedSecret) {
      const encoder = new TextEncoder();

      const keyData = encoder.encode(sharedSecret);

      const messageData = encoder.encode(message);

      const cryptoKey = await window.crypto.subtle.importKey(
        "raw",
        keyData,
        {
          name: "HMAC",
          hash: "SHA-256",
        },
        false,
        ["sign"],
      );

      const signatureBuffer = await window.crypto.subtle.sign(
        "HMAC",
        cryptoKey,
        messageData,
      );

      return Array.from(new Uint8Array(signatureBuffer))
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
    },
  },
};
</script>

<style scoped>
.sso-loading {
  padding: 40px;
  text-align: center;
  font-size: 16px;
}
</style>
